import React from 'react';
import { Link } from 'react-router-dom';  // <-- Import Link

const CommunityPriceUpdate = () => {
  const codes = {
    'Starter Club': {
      originalPrice: '10,00,000',
      offerPrice: '1,25,000 BDT',
      topics: [
        'For Action-Takers Starting Out',
        'Total Value: 10,00,000 BDT',
        'Join Now: 1,25,000 BDT',
      ],
    },
    'Rich Club': {
      originalPrice: '45,00,000 BDT',
      offerPrice: '12,00,000 BDT',
      topics: [
        'For Growth-Focused Entrepreneurs',
        'Total Value: 45,00,000 BDT',
        'Join Now: 12,00,000 BDT',
      ],
    },
    'Elite Club': {
      originalPrice: '55,00,000 BDT',
      offerPrice: '30,00,000 BDT',
      topics: [
        'For Leaders Ready to Multiply',
        'Total Value: 55,00,000 BDT',
        'Join Now: 30,00,000 BDT',
      ],
    },
    'Capital Club': {
      originalPrice: '100,000,000 BDT',
      offerPrice: '12,000,000 BDT',
      topics: [
        'For Visionaries Seeking Wealth & Legacy',
        'Total Value: 100,000,000 BDT',
        'Join Now: 12,000,000 BDT',
      ],
    },
  };

    const boxStyle = {
    flex: '1 1 400px', // <-- Base width for the card
    padding: '20px',
    border: '1px solid violet',
    backgroundColor: 'rgba(238, 130, 238, 0.1)',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };

  const linkStyle = {
    display: 'inline-block',
    marginTop: '20px',
    padding: '10px 20px',
    backgroundColor: 'purple',
    color: 'white',
    borderRadius: '6px',
    textDecoration: 'none',
    fontSize: '16px',
    textAlign: 'center',
  };

  // Helper function to extract number from offerPrice string
  const extractAmount = (priceStr) => {
    // Remove non-numeric characters (keep dot if you want decimals)
    const numericStr = priceStr.replace(/[^\d.]/g, '');
    return numericStr;
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
      {Object.entries(codes).map(([codeTitle, { originalPrice, offerPrice, topics }]) => (
        <div key={codeTitle} style={boxStyle}>
          <div>
            <h3 style={{ color: '', marginBottom: '10px' }} className='text-center'>{codeTitle}</h3>
            <ul style={{ paddingLeft: '20px' }}>
              {topics.map((topic, idx) => (
                <li key={idx} style={{ marginBottom: '8px' }}>{topic}</li>
              ))}
            </ul>
          </div>
          <div style={{ marginTop: 'auto' }} className="text-center">
            <h4 style={{ margin: '20px 0 10px 0' }}>
              Total Value: <del style={{ color: 'gray', marginRight: '10px' }}>{originalPrice}</del><br />
              Join Now: <span style={{ color: 'green', fontWeight: 'bold' }}>{offerPrice}</span>
            </h4>
            <div className="text-center">
              <Link
                className="btn-default"
                to={`/order?service=Community&package=${encodeURIComponent(codeTitle)}&amount=${extractAmount(offerPrice)}`}              >
                Purchase Now
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommunityPriceUpdate;
